import { render, staticRenderFns } from "./UserDocumentation.vue?vue&type=template&id=b0800ac8"
import script from "../../../scripts/partials/user/UserDocumentation.js?vue&type=script&lang=js&external"
export * from "../../../scripts/partials/user/UserDocumentation.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports